import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { IPropuestaSuperEjecutivo } from '../super-ejecutivo.interface';
import { SuperEjecutivoMarkdownComponent } from '../super-ejecutivo-markdown/super-ejecutivo-markdown.component';

/** Propuesta de acción del Super Ejecutivo con Autorizar y Rechazar (RN14-RN16). */
@Component({
  selector: 'app-super-ejecutivo-propuesta',
  templateUrl: './super-ejecutivo-propuesta.component.html',
  styleUrl: './super-ejecutivo-propuesta.component.css',
  imports: [MatButton, MatIcon, SuperEjecutivoMarkdownComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuperEjecutivoPropuestaComponent {
  public readonly propuesta = input.required<IPropuestaSuperEjecutivo>();
  /** El Super Ejecutivo está respondiendo: no se puede contestar todavía. */
  public readonly deshabilitada = input(false);
  /** true si el usuario autoriza; false si rechaza. */
  public readonly decidir = output<boolean>();
}
